import {Plans} from './plans'
export default {
  createAccount:(sub,accounts)=>{
    if(sub.active){
      if(sub.plan==="free"){
        return accounts<1
      }
      if(Plans[sub.plan]){
        return accounts < Plans[sub.plan].accounts
      }
      return false
    }else{
      return accounts<1
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/permissions.js